import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';

const stats = [
  { value: '1,200+', label: 'Asociados Activos', detail: 'Comunidad en crecimiento' },
  { value: '24/7', label: 'Monitorio de Red', detail: 'Suministro garantizado' },
  { value: '100%', label: 'Eficiencia Digital', detail: 'Procesos optimizados' },
  { value: '15+', label: 'Años de Servicio', detail: 'Experiencia y solidez' }
];

const LandingStats = () => {
  return (
    <Box id="stats" sx={{ py: 10, background: 'linear-gradient(135deg, #00241b 0%, #004D40 100%)', color: 'white' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
          {stats.map((stat, index) => (
            <Grid key={index} sx={{ textAlign: 'center' }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 900,
                  mb: 1,
                  background: 'linear-gradient(to bottom, #fff 50%, #4DB6AC 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {stat.value}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                {stat.label}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                {stat.detail}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingStats;
